import cn from "classnames";
import { NavigationIcon } from "../navigation-icon";
import { getYearsRange } from "./utils";
import { YearsProps } from "./types";
import styles from "./styles.module.scss";

export const Years = ({
  minYear = 1930,
  maxYear = new Date().getFullYear(),
  selectedYear,
  onSelectYear,
  showStartPanel,
  dataTestId,
}: YearsProps) => {
  const years = getYearsRange(minYear, maxYear);

  return (
    <div className={styles.panel} data-test-id={dataTestId}>
      <header className={styles.header}>
        <NavigationIcon
          direction="left"
          onClick={showStartPanel}
          dataTestId={`${dataTestId}-back`}
        />
        <span className={styles.title}>Выберите год</span>
      </header>
      <div className={styles.years}>
        {years.map((year) => (
          <span
            className={cn(styles.year, {
              [styles.selected]: year === selectedYear,
            })}
            onClick={() => onSelectYear(year)}
            key={`year-${year}`}
          >
            {year}
          </span>
        ))}
      </div>
    </div>
  );
};
